export default __webpack_public_path__ + "static/media/FotosVideos.d308b8df.svg";